import { v4 as uuid } from "uuid";

/**
 * Brand Database can be added here.
 * You can add brand of your wish with different attributes
 * */

export const brands = [
  {
    _id: uuid(),
    brandName: "celestron",
    value: "celestron",
  },
  {
    _id: uuid(),
    brandName: "generic",
    value: "generic",
    },
  {
    _id: uuid(),
    brandName: "meade",
    value: "meade",
  },
  {
    _id: uuid(),
    brandName: "aomeike",
    value: "aomeike",
   },
]